import { cn } from '@/lib/utils';

import PricingSectionPriceCardCell from '@/blocks/PricingSection/Desktop/Components/PricingSectionPriceCardCell';
import Card from '@/components/atoms/Card';

import PricingSectionBadgeOfHonor from '../../Common/PricingSectionBadgeOfHonor';
import { PricingSectionCardProps } from '../../types';
import PricingSectionCardCTA from './PricingSectionCardCTA';

const PricingSectionCardColumn = (column: PricingSectionCardProps) => {
  return (
    <div className='relative flex flex-1 h-full'>
      <Card
        hasHoverEffect={!column.badgeOfHonor}
        classNames={{
          root: cn(
            'group/column',
            'flex-1 flex flex-col gap-y-[1px]',
            'p-0 cursor-default',
            !!column.badgeOfHonor && '!border-brand-500',
            column.badgeOfHonor && 'absolute -top-6 w-full'
          ),
        }}
      >
        {!!column.badgeOfHonor && (
          <PricingSectionBadgeOfHonor>
            {column.badgeOfHonor}
          </PricingSectionBadgeOfHonor>
        )}
        <PricingSectionPriceCardCell
          isHeaderCell
          primaryText={column.cardHeader}
          hasBadgeOfHonor={!!column.badgeOfHonor}
        />
        {column.rows.map((row, index) => (
          <PricingSectionPriceCardCell
            key={index}
            isHeaderCell={false}
            {...row}
            hasBadgeOfHonor={!!column.badgeOfHonor}
          />
        ))}
        <PricingSectionPriceCardCell
          isHeaderCell={false}
          secondaryText={column.rateLimit}
          hasBadgeOfHonor={!!column.badgeOfHonor}
        />
        {column.ctaButton && (
          <PricingSectionCardCTA
            type={column.type}
            ctaButton={column.ctaButton}
            badgeOfHonor={column.badgeOfHonor}
            cardHeader={column.cardHeader}
          />
        )}
      </Card>
    </div>
  );
};

export default PricingSectionCardColumn;
